import React, { useState } from 'react';
import Joyride, { CallBackProps } from 'react-joyride';

import disableModal, {
  DISABLED_MODALS,
} from 'components/manage/guestlist/addressCollection/helpers/disableModal';

import TourTooltip from 'components/common/ui/Tour/TourTooltip/TourTooltip';
import STEPS from './Steps';

import styles from './ManageAddressCollectionLinkTour.module.less';

const ManageAddressCollectionLinkTour: React.FC = () => {
  const [isRunning, setIsRunning] = useState(true);
  const handleJoyrideCallback = (data: CallBackProps): void => {
    // For some reason, when clicking on joyride overlay goes to the next
    // step, instead of closing even though the action === 'close';
    // so explicitly forcing it to close here
    if (data.type === 'tour:end' || data.action === 'close') {
      setIsRunning(false);
      disableModal(DISABLED_MODALS.MAGIC_LINK_TOUR);
    }
  };

  return (
    <div className={styles.wrapper}>
      <Joyride
        run={isRunning}
        steps={STEPS}
        callback={handleJoyrideCallback}
        showProgress
        continuous
        showSkipButton
        hideBackButton
        disableScrollParentFix
        scrollOffset={500} // add arbitrary padding to scroll so that the whole dashboard progress tab section is in view during tour
        styles={{ options: { zIndex: 1000 } }}
        tooltipComponent={TourTooltip}
        floaterProps={{
          disableAnimation: true,
        }}
      />
    </div>
  );
};

export default ManageAddressCollectionLinkTour;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/addressCollection/ManageAddressCollectionLinkTour/ManageAddressCollectionLinkTour.tsx